import { render } from "./formulas.html?vue&type=template&id=6c27e286&scoped=true&external"
import script from "./formulas.vue?vue&type=script&lang=js"
export * from "./formulas.vue?vue&type=script&lang=js"

import "./formulas.vue?vue&type=style&index=0&id=6c27e286&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6c27e286"]])

export default __exports__